<template>
  <BlockListThumbnails
    v-if="thumbnails.length"
    :thumbnails="thumbnails"
    :title="title"
  />
</template>
<script lang="ts" setup>
interface Props {
  ids: string[];
  title?: string;
}
const props = defineProps({
  ids: null,
  title: null
});

const { currentContent } = inject(INJECT_CATEGORY_PAGE);

const { thumbnails, loadThumbnails } = await useCategoryOthersThumbnails(
  props.ids,
  currentContent.value.id,
  'essential'
);
onMounted(async () => {
  await loadThumbnails();
});
</script>
